'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewModule = function ActionViewModule(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z' })
  );
};
ActionViewModule = (0, _pure2.default)(ActionViewModule);
ActionViewModule.displayName = 'ActionViewModule';
ActionViewModule.muiName = 'SvgIcon';

exports.default = ActionViewModule;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/view-module.js
// module id = 1949
// module chunks = 0